<!-- Spinner-Overlay -->
<div class="overlay" *ngIf="isProcessing">
    <clr-spinner clrMedium clrInline>Bitte warten…</clr-spinner>
</div>

<!-- Sticky panel header: identity + status + primary actions, always visible
     while the accordion body scrolls underneath. -->
<div class="details-header">
  <div class="details-header-meta">
    <img *ngIf="broadcast?.instanceInitializing" src="assets/anim-orange-rotate.svg" class="rotating-icon" alt="LIVE-Container initializing">
    <img *ngIf="broadcast?.recordingStarted" src="assets/anim-green-rotate.svg" class="rotating-icon" alt="LIVE-Container initializing">
    <span *ngIf="broadcast?.live" class="live-badge">LIVE</span>
    <span *ngIf="broadcast?.kiut" class="kiut-badge">KIUT</span>
    <span *ngIf="broadcast?.channel">{{ broadcast.channel }}</span>
    <span class="u-nowrap" *ngIf="broadcast?.startTime">{{ broadcast.startTime | date: 'HH:mm:ss' }}</span>
    <span class="voxtral-status voxtral-idle" *ngIf="!broadcast?.voxtralMini4bRealtimeEc2IP && !broadcast?.voxtralMini4bRealtimeEc2StoppedAt">Voxtral inaktiv</span>
    <span class="voxtral-status voxtral-starting" *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP === 'blocked'">EC2 wird gestartet…</span>
    <span class="voxtral-status voxtral-running" *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2IP !== 'blocked' && broadcast?.voxtralMini4bRealtimeSessionId">Transkription aktiv</span>
    <span class="voxtral-status voxtral-starting" *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2IP !== 'blocked' && !broadcast?.voxtralMini4bRealtimeSessionId">Session wird erstellt…</span>
    <span class="voxtral-status voxtral-finished" *ngIf="!broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2StoppedAt">Voxtral beendet</span>
  </div>
  <div class="details-header-actions">
    <!-- Audio player toggle — same icon affordance as the Programmplan
         header. Voxtral Start/Stop live in the Voxtral-Steuerung section. -->
    <button class="btn btn-sm btn-icon"
            [class.btn-success-outline]="!voxtralPlayerPlaying"
            [class.btn-danger-outline]="voxtralPlayerPlaying"
            [disabled]="voxtralPlayerConnecting"
            (click)="toggleVoxtralPlayer()"
            [title]="voxtralPlayerActiveOtherChannel
                      ? 'Aktuell läuft ' + voxtralPlayerActiveOtherChannel + ' — Play wechselt auf ' + broadcast?.channel
                      : 'Live-Player für ' + broadcast?.channel + ' (steuert den Player im Programmplan)'">
      <clr-spinner *ngIf="voxtralPlayerConnecting" clrSmall clrInline></clr-spinner>
      <cds-icon *ngIf="!voxtralPlayerConnecting" [attr.shape]="voxtralPlayerPlaying ? 'stop' : 'play'"></cds-icon>
    </button>
    <ng-container *hasPermission="'control-voxtral'">
      <button class="btn btn-sm btn-danger-outline"
              *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2IP !== 'blocked'"
              [disabled]="voxtralStopping"
              (click)="stopVoxtral()">
        <clr-spinner *ngIf="voxtralStopping" clrSmall clrInline></clr-spinner>
        Stop
      </button>
    </ng-container>
  </div>
</div>

<clr-accordion [clrAccordionMultiPanel]="true" class="details-accordion">

  <!-- ======================= Allgemein ======================= -->
  <clr-accordion-panel [(clrAccordionPanelOpen)]="open.allgemein">
    <clr-accordion-title>Allgemein</clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>

      <!-- broadcast.Key for forensic lookups (S3 paths, DDB queries,
           CloudWatch filters). Read-only. -->
      <div class="info-row">
        <span class="info-label">Key:</span>
        <span class="info-value u-mono-break" [title]="broadcast?.key">{{ broadcast?.key }}</span>
      </div>

      <fieldset class="rbac-fieldset" disableUnlessPermission="manage-broadcasts">
        <div class="info-row">
          <span class="info-label">KIUT:</span>
          <clr-checkbox-container class="info-value">
            <label>
              <input
                clrCheckbox
                type="checkbox"
                name="kiut"
                [(ngModel)]="broadcast.kiut"
                (ngModelChange)="onKiutToggle($event)"
              />
            </label>
          </clr-checkbox-container>
        </div>

        <div class="info-row">
          <span class="info-label">Stream Source:</span>
          <select
            class="clr-select"
            [ngModel]="broadcast.liveStreamSource"
            (ngModelChange)="onLiveStreamSourceChange($event)"
            [disabled]="savingLiveStreamSource"
          >
            <option value="Encoder">Encoder</option>
            <option value="Fanout">Fanout</option>
          </select>
        </div>
      </fieldset>

      <div *ngIf="broadcast?.vpsCode" class="info-row">
        <span class="info-label">VPS:</span>
        <span class="info-value">{{ broadcast.vpsCode }}</span>
      </div>
      <div *ngIf="broadcast?.channel" class="info-row">
        <span class="info-label">Sender:</span>
        <span class="info-value">{{ broadcast.channel }}</span>
      </div>

      <div *ngIf="broadcast?.channel" class="info-row">
        <span class="info-label">Startzeit:</span>
        <ng-container *ngIf="!editingStartTime; else editStartTpl">
          <span class="info-value">
            {{ broadcast.startTime | date: 'HH:mm:ss' }}
            <ng-container *hasPermission="'manage-broadcasts'">
              <cds-icon shape="pencil" class="edit-icon" (click)="beginEditStartTime()" aria-label="Bearbeiten"></cds-icon>
            </ng-container>
          </span>
        </ng-container>
        <ng-template #editStartTpl>
          <input
            type="time"
            step="1"
            class="clr-input"
            [(ngModel)]="startTimeInput"
            (keyup.enter)="saveStartTime()"
            (keydown.escape)="cancelEditStartTime()"
            autofocus
          />
        </ng-template>
      </div>

      <div *ngIf="broadcast?.channel" class="info-row">
        <span class="info-label">Dauer:</span>
        <span class="info-value info-value-actions">
          <ng-container *ngIf="!editingDuration; else editDurationTpl">
            <span>
              {{ broadcast.bruttoDuration | durationFormat }}
              <ng-container *hasPermission="'manage-broadcasts'">
                <cds-icon shape="pencil" class="edit-icon" (click)="beginEditDuration()" aria-label="Bearbeiten"></cds-icon>
              </ng-container>
            </span>
          </ng-container>
          <ng-template #editDurationTpl>
            <input
              type="text"
              placeholder="HH:mm:ss"
              class="clr-input"
              [(ngModel)]="durationInput"
              (keyup.enter)="saveDuration()"
              (keydown.escape)="cancelEditDuration()"
              autofocus
            />
          </ng-template>
          <button clrButton [disabled]="!canManageBroadcasts" (click)="fetchStartDurationFromRedsysAsync()">Redsys abfragen</button>
        </span>
      </div>

      <div *ngIf="broadcast?.channel" class="info-row">
        <span class="info-label">DDS Start:</span>
        <span class="info-value">{{ broadcast.ddsStartsAt | date: 'HH:mm:ss' }}</span>
      </div>
      <div *ngIf="broadcast?.channel" class="info-row">
        <span class="info-label">DDS Ende:</span>
        <span class="info-value">{{ broadcast.ddsEndsAt | date: 'HH:mm:ss' }}</span>
      </div>

      <div class="info-row">
        <span class="info-label">Redsys Sendungsname:</span>
        <ng-container *ngIf="!editingRedsysSendungsname; else editRedsysNameTpl">
          <span class="info-value">
            {{ broadcast?.redsysSendungsname || '—' }}
            <ng-container *hasPermission="'manage-broadcasts'">
              <cds-icon shape="pencil" class="edit-icon" (click)="beginEditRedsysSendungsname()" aria-label="Bearbeiten"></cds-icon>
            </ng-container>
          </span>
        </ng-container>
        <ng-template #editRedsysNameTpl>
          <input
            type="text"
            class="clr-input"
            [(ngModel)]="redsysNameInput"
            (keyup.enter)="saveRedsysSendungsname()"
            (keydown.escape)="cancelEditRedsysSendungsname()"
            autofocus
          />
        </ng-template>
      </div>
    </clr-accordion-content>
  </clr-accordion-panel>

  <!-- ================== Voxtral-Steuerung ==================== -->
  <clr-accordion-panel [(clrAccordionPanelOpen)]="open.voxtral">
    <clr-accordion-title>
      Voxtral-Steuerung
      <span class="voxtral-status voxtral-running accordion-title-chip" *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2IP !== 'blocked' && broadcast?.voxtralMini4bRealtimeSessionId">Session läuft</span>
      <span class="voxtral-status voxtral-starting accordion-title-chip" *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP === 'blocked'">EC2 startet</span>
    </clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>
      <div class="voxtral-section">

        <section class="v-subsection">
          <h5 class="v-subsection-title">Steuerung</h5>

          <div class="info-row">
            <span class="info-label">Status:</span>
            <span class="info-value">
              <span *ngIf="!broadcast?.voxtralMini4bRealtimeEc2IP && !broadcast?.voxtralMini4bRealtimeEc2StoppedAt" class="voxtral-status voxtral-idle">Inaktiv</span>
              <span *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP === 'blocked'" class="voxtral-status voxtral-starting">EC2 wird gestartet...</span>
              <span *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2IP !== 'blocked' && broadcast?.voxtralMini4bRealtimeSessionId" class="voxtral-status voxtral-running">Transkription aktiv</span>
              <span *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2IP !== 'blocked' && !broadcast?.voxtralMini4bRealtimeSessionId" class="voxtral-status voxtral-starting">Session wird erstellt...</span>
              <span *ngIf="!broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2StoppedAt" class="voxtral-status voxtral-finished">Beendet</span>
              <!-- 2026-08-04 — the session can look perfectly healthy (EC2 +
                   Session ID present, /health 200) while vLLM is wedged and no
                   caption has been produced for half an hour. Set by the
                   reconciler's stall watchdog; see SessionStallDetector. -->
              <span *ngIf="broadcast?.voxtralMini4bRealtimeStalledSince" class="label label-danger voxtral-stalled-badge">
                Keine Untertitel seit {{ broadcast.voxtralMini4bRealtimeStalledSince | date: 'HH:mm' }} — Session neu starten
              </span>
            </span>
          </div>

          <div *ngIf="broadcast?.voxtralMini4bRealtimeEc2IP && broadcast?.voxtralMini4bRealtimeEc2IP !== 'blocked'" class="info-row">
            <span class="info-label">EC2 IP:</span>
            <span class="info-value info-value-actions">
              <a class="voxtral-ip-link"
                 [href]="'http://' + broadcast.voxtralMini4bRealtimeEc2IP"
                 target="_blank"
                 rel="noopener"
                 [title]="'Voxtral-Server öffnen: http://' + broadcast.voxtralMini4bRealtimeEc2IP">
                {{ broadcast.voxtralMini4bRealtimeEc2IP }}
              </a>
            </span>
          </div>

          <div *ngIf="voxtralSessionApiBase" class="info-row">
            <span class="info-label">Session API:</span>
            <span class="info-value voxtral-session-api-links">
              <a [href]="voxtralSessionApiBase + '/corrections'" target="_blank" rel="noopener"
                 title="Letzte 100 angewendete + blockierte Korrekturen (JSON).">
                /corrections ↗
              </a>
              <a [href]="voxtralSessionApiBase + '/segments'" target="_blank" rel="noopener"
                 title="Segment-Zeitachse (JSON).">
                /segments ↗
              </a>
            </span>
          </div>

          <!-- Timestamps -->
          <div *ngIf="broadcast?.voxtralMini4bRealtimeEc2StartedAt" class="info-row">
            <span class="info-label">EC2 Start:</span>
            <span class="info-value">{{ broadcast.voxtralMini4bRealtimeEc2StartedAt | date: 'HH:mm:ss' }}</span>
          </div>
          <div *ngIf="broadcast?.voxtralMini4bRealtimeSessionStartedAt" class="info-row">
            <span class="info-label">Session Start:</span>
            <span class="info-value">{{ broadcast.voxtralMini4bRealtimeSessionStartedAt | date: 'HH:mm:ss' }}</span>
          </div>
          <div *ngIf="broadcast?.voxtralMini4bRealtimeSessionStoppedAt" class="info-row">
            <span class="info-label">Session Ende:</span>
            <span class="info-value">{{ broadcast.voxtralMini4bRealtimeSessionStoppedAt | date: 'HH:mm:ss' }}</span>
          </div>
          <div *ngIf="broadcast?.voxtralMini4bRealtimeEc2StoppedAt" class="info-row">
            <span class="info-label">EC2 Ende:</span>
            <span class="info-value">{{ broadcast.voxtralMini4bRealtimeEc2StoppedAt | date: 'HH:mm:ss' }}</span>
          </div>

          <!-- 2026-10-09 — the session's whole export as one JSON file:
               segments, corrections, prompts and the speaker diarization. -->
          <div *ngIf="broadcast?.voxtralMini4bRealtimeSegmentsS3Key || broadcast?.voxtralMini4bRealtimeSessionId" class="info-row">
            <span class="info-label">Transkript:</span>
            <span class="info-value">
              <button type="button" class="btn btn-sm btn-outline"
                      (click)="downloadVoxtralExport()"
                      [disabled]="voxtralExportDownloading"
                      title="Segmente, Korrekturen, Prompts und Sprecher-Diarisierung als JSON. Während die Session läuft, der aktuelle Stand vom Voxtral-Server, danach die Kopie in S3.">
                <cds-icon shape="download"></cds-icon>
                {{ voxtralExportDownloading ? 'Lade…' : 'JSON herunterladen' }}
              </button>
              <span *ngIf="broadcast?.voxtralMini4bRealtimeSegmentsCount" class="count-badge">
                {{ broadcast.voxtralMini4bRealtimeSegmentsCount }} Segmente
              </span>
            </span>
          </div>

          <fieldset class="rbac-fieldset" disableUnlessPermission="manage-broadcasts">
            <div class="info-row">
              <span class="info-label">Planung:</span>
              <span class="info-value">
                <label>
                  <input
                    type="checkbox"
                    [checked]="!!broadcast?.voxtralMini4bRealtimeScheduled"
                    [disabled]="voxtralScheduleToggling"
                    (change)="toggleVoxtralSchedule()" />
                  Für Voxtral planen
                </label>
                <clr-spinner *ngIf="voxtralScheduleToggling" clrSmall clrInline></clr-spinner>
                <span *ngIf="broadcast?.voxtralMini4bRealtimeOperatorStoppedAt" class="voxtral-veto-note">
                  Manuell gestoppt am {{ broadcast.voxtralMini4bRealtimeOperatorStoppedAt | date: 'short' }}
                </span>
              </span>
            </div>
          </fieldset>

          <div class="info-row" *hasPermission="'control-voxtral'">
            <span class="info-label">Aktionen:</span>
            <span class="info-value voxtral-actions">
              <button
                class="btn btn-sm btn-success-outline"
                [disabled]="!!broadcast?.voxtralMini4bRealtimeEc2IP || voxtralStarting"
                (click)="startVoxtral()">
                <clr-spinner *ngIf="voxtralStarting" clrSmall clrInline></clr-spinner>
                Start
              </button>
              <button
                class="btn btn-sm btn-danger-outline"
                [disabled]="!broadcast?.voxtralMini4bRealtimeEc2IP || broadcast?.voxtralMini4bRealtimeEc2IP === 'blocked' || voxtralStopping"
                (click)="stopVoxtral()">
                <clr-spinner *ngIf="voxtralStopping" clrSmall clrInline></clr-spinner>
                Stop
              </button>
              <button
                class="btn btn-sm btn-warning-outline"
                [disabled]="voxtralResetting || (!broadcast?.voxtralMini4bRealtimeEc2IP && !broadcast?.voxtralMini4bRealtimeEc2StoppedAt && !broadcast?.voxtralMini4bRealtimeEc2StartedAt)"
                (click)="resetVoxtral()">
                <clr-spinner *ngIf="voxtralResetting" clrSmall clrInline></clr-spinner>
                Reset
              </button>
              <button
                class="btn btn-sm btn-danger"
                [disabled]="voxtralTerminating"
                (click)="terminateVoxtral()">
                <clr-spinner *ngIf="voxtralTerminating" clrSmall clrInline></clr-spinner>
                Terminate
              </button>
            </span>
          </div>

          <div *ngIf="voxtralError" class="voxtral-error">{{ voxtralError }}</div>

          <div *ngIf="voxtralPlayerActiveOtherChannel" class="voxtral-player-other">
            Aktuell läuft: <strong>{{ voxtralPlayerActiveOtherChannel }}</strong> — Play wechselt auf {{ broadcast?.channel }}
          </div>
          <div *ngIf="voxtralPlayerError" class="voxtral-error">{{ voxtralPlayerError }}</div>
        </section>

        <fieldset class="rbac-fieldset" disableUnlessPermission="manage-broadcasts">
        <section class="v-subsection" *ngIf="!broadcast?.voxtralMini4bRealtimeEc2StoppedAt">
          <h5 class="v-subsection-title">FAB</h5>

          <!-- FAB toggle. Visible until the broadcast is permanently stopped;
               posts to voxtral-fab-enabled which persists AND live-updates
               the running session via the forwarder's pending_fab_enabled gate. -->
          <div class="info-row">
            <span class="info-label">FAB:</span>
            <span class="info-value">
              <label>
                <input type="checkbox" [(ngModel)]="voxtralFabEnabled"
                       [disabled]="voxtralFabEnabledSaving"
                       (ngModelChange)="onVoxtralFabEnabledChanged($event)" />
                Aktiviert
              </label>
              <clr-spinner *ngIf="voxtralFabEnabledSaving" clrSmall clrInline></clr-spinner>
              <span *ngIf="voxtralFabPending" class="label label-warning pending-chip">
                Wird übernommen…
              </span>
            </span>
          </div>

          <!-- 2026-07-02 — per-broadcast DDS-interval FAB gate. -->
          <div *ngIf="voxtralFabEnabled" class="info-row">
            <span class="info-label">FAB nach DDS:</span>
            <span class="info-value">
              <label>
                <input type="checkbox" [(ngModel)]="voxtralIsFabDdsStartStopActive"
                       [disabled]="voxtralIsFabDdsStartStopActiveSaving"
                       (ngModelChange)="onVoxtralIsFabDdsStartStopActiveChanged($event)" />
                FAB nach DDS Start und Stop aktivieren
              </label>
              <clr-spinner *ngIf="voxtralIsFabDdsStartStopActiveSaving" clrSmall clrInline></clr-spinner>
              <span *ngIf="voxtralIsFabDdsStartStopActivePending" class="label label-warning pending-chip">
                Wird übernommen…
              </span>
              <!-- 2026-08-04 — the gate is the single most surprising reason for
                   "Transkription läuft, aber nichts geht auf Sendung". On the
                   ORFS outage a session ran 4½ min on a row whose DDS window was
                   1½ h away and sent 0 messages, with nothing on screen to say so. -->
              <span *ngIf="fabGateClosedUntil()" class="label label-danger fab-gate-badge">
                FAB gesperrt bis {{ fabGateClosedUntil() | date: 'HH:mm' }} (DDS-Fenster)
              </span>
              <span *ngIf="fabGateClosedUntil()" class="fab-gate-hint">
                Die Transkription läuft, sendet aber nicht. Häkchen entfernen, um sofort an FAB zu senden.
              </span>
            </span>
          </div>

          <!-- 2026-06-08 — FAB URL editor stays visible mid-broadcast;
               debounced persist + live-update via pending_fab_url gate. -->
          <div *ngIf="voxtralFabEnabled" class="info-row">
            <span class="info-label">FAB URL:</span>
            <span class="info-value faburl-row">
              <input type="text" class="clr-input faburl-input"
                     [(ngModel)]="voxtralFabUrl"
                     (ngModelChange)="onVoxtralFabUrlChanged($event)"
                     [disabled]="voxtralFabUrlSaving"
                     [placeholder]="defaultFabUrlForCurrentChannel()" />
              <clr-spinner *ngIf="voxtralFabUrlSaving" clrSmall clrInline></clr-spinner>
              <span *ngIf="voxtralFabUrlPending" class="label label-warning pending-chip">
                Wird übernommen…
              </span>
            </span>
          </div>

          <div *ngIf="!broadcast?.voxtralMini4bRealtimeEc2IP && voxtralFabEnabled" class="info-row">
            <span class="info-label">FAB Modus:</span>
            <span class="info-value">
              <select class="clr-select" [(ngModel)]="voxtralFabSendType">
                <option value="cursor">Cursor (geringe Latenz)</option>
                <option value="growing">Growing (stabilitätsbasiert)</option>
                <option value="confirmed">Confirmed (nur finale Segmente)</option>
              </select>
            </span>
          </div>
        </section>
        </fieldset>

        <!-- 2026-09-28 — live speaker diarization. Speaker labels are shown in
             the LIVE panel only (Aktuell / Transkript / Segmente Zeitachse);
             FAB never receives them. Persists AND live-updates a running
             session via voxtral-diarization-enabled. -->
        <fieldset class="rbac-fieldset" disableUnlessPermission="manage-broadcasts">
        <section class="v-subsection" *ngIf="!broadcast?.voxtralMini4bRealtimeEc2StoppedAt">
          <h5 class="v-subsection-title">Sprecher</h5>
          <div class="info-row">
            <span class="info-label">Diarisierung:</span>
            <span class="info-value">
              <label>
                <input type="checkbox" [(ngModel)]="voxtralDiarizationEnabled"
                       [disabled]="voxtralDiarizationSaving"
                       (ngModelChange)="onVoxtralDiarizationEnabledChanged($event)" />
                Sprecher-Diarisierung (nur Anzeige, nicht an FAB)
              </label>
              <clr-spinner *ngIf="voxtralDiarizationSaving" clrSmall clrInline></clr-spinner>
              <span *ngIf="voxtralDiarizationPending" class="label label-warning pending-chip">
                Wird übernommen…
              </span>
              <span *ngIf="voxtralDiarizationEnabled && (voxtralDiarizationState === 'unavailable' || voxtralDiarizationState === 'disabled')"
                    class="label label-danger pending-chip"
                    title="Die EC2-Instanz hat keinen laufenden Diarisierungsdienst (z. B. älteres AMI).">
                nicht verfügbar
              </span>
            </span>
          </div>
        </section>
        </fieldset>

        <!-- FAB info (when running or finished — also after EC2 stop, hence
             OUTSIDE the !Ec2StoppedAt-guarded FAB subsection). -->
        <div *ngIf="broadcast?.voxtralMini4bRealtimeFabEnabled" class="info-row">
          <span class="info-label">FAB:</span>
          <span class="info-value u-wrap">{{ broadcast.voxtralMini4bRealtimeFabMode }} &rarr; {{ broadcast.voxtralMini4bRealtimeFabUrl }}</span>
        </div>

        <fieldset class="rbac-fieldset" disableUnlessPermission="manage-broadcasts">
        <section class="v-subsection" *ngIf="!broadcast?.voxtralMini4bRealtimeEc2StoppedAt">
          <h5 class="v-subsection-title">Korrektur</h5>

          <!-- Correction mode selector: phonetic | off | fuzzy.
               Persists AND live-updates at the next sentence FINAL boundary. -->
          <div class="info-row">
            <span class="info-label">Korrektur:</span>
            <span class="info-value">
              <select class="clr-select korrektur-mode-select"
                      [disabled]="voxtralCorrectionToggling"
                      [ngModel]="voxtralCorrectionMode"
                      (ngModelChange)="onCorrectionModeChange($event)">
                <option value="phonetic">Phonetisch</option>
                <option value="off">Aus</option>
                <option value="fuzzy">Fuzzy</option>
              </select>
              <clr-spinner *ngIf="voxtralCorrectionToggling" clrSmall clrInline></clr-spinner>
              <span *ngIf="voxtralCorrectionPending" class="label label-warning pending-chip"
                    title="Die neue Korrektur-Einstellung wird beim nächsten Satzende übernommen.">
                Wird ab nächstem Satzende übernommen
              </span>
            </span>
          </div>

          <!-- Korrektur-Kontext. Visible as long as any correction mode is on. -->
          <div *ngIf="voxtralCorrectionEnabled" class="info-row">
            <span class="info-label">
              <button type="button" class="v-disclosure" [attr.aria-expanded]="voxtralCorrectionContextExpanded"
                      (click)="voxtralCorrectionContextExpanded = !voxtralCorrectionContextExpanded">
                Korrektur-Kontext
                <cds-icon shape="angle" [attr.direction]="voxtralCorrectionContextExpanded ? 'down' : 'right'" size="14"></cds-icon>
              </button>
            </span>
            <span class="info-value" *ngIf="!voxtralCorrectionContextExpanded && voxtralCorrectionContext">
              <span class="label label-info pending-chip">{{ voxtralCorrectionContext.length }} Zeichen</span>
            </span>
          </div>
          <div *ngIf="voxtralCorrectionEnabled && voxtralCorrectionContextExpanded" class="info-row info-row-full">
            <span class="info-value u-full">
              <span class="voxtral-context-hint u-block hint-lead">
                Listen können komma- oder zeilenweise (LF/CRLF) eingegeben werden — beide Formate werden akzeptiert.
              </span>
              <!-- Phase 3.2 — operator editor for v2 correction-context shape. -->
              <app-voxtral-correction-context-editor
                [currentJson]="voxtralCorrectionContext"
                [saving]="voxtralCorrectionContextSaving"
                (applyToBroadcast)="onCorrectionContextApplied($event)">
              </app-voxtral-correction-context-editor>
              <span *ngIf="voxtralCorrectionContextError" class="label label-danger u-chip-block">
                {{ voxtralCorrectionContextError }}
              </span>
              <span *ngIf="voxtralCorrectionContextSavedAt" class="label label-success u-chip-block">
                Gespeichert {{ voxtralCorrectionContextSavedAt | date: 'HH:mm:ss' }}
              </span>
              <span class="voxtral-context-hint u-block">
                {{ voxtralCorrectionContextHint }} (wird beim nächsten Session-Start angewendet)
              </span>
            </span>
          </div>
        </section>
        </fieldset>

      </div>
    </clr-accordion-content>
  </clr-accordion-panel>

  <!-- ===================== Live-Daten ======================== -->
  <clr-accordion-panel [(clrAccordionPanelOpen)]="open.voxtralLive">
    <clr-accordion-title>
      Voxtral-Transkription (LIVE)
      <span class="count-badge" *ngIf="voxtralTranscriptLines.length">{{ voxtralTranscriptLines.length }} Zeilen</span>
      <span class="count-badge" *ngIf="voxtralRecentCorrections.length">K {{ voxtralRecentCorrections.length }}</span>
      <span class="count-badge" *ngIf="voxtralSegmentTimeline.length">Seg {{ voxtralSegmentTimeline.length }}</span>
    </clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>
      <app-voxtral-live-data
        [voxtralSystemMessages]="voxtralSystemMessages"
        [voxtralCurrentText]="voxtralCurrentText"
        [voxtralCurrentHtml]="voxtralCurrentHtml"
        [voxtralCurrentSpeaker]="voxtralCurrentSpeaker"
        [voxtralTranscriptLines]="voxtralTranscriptLines"
        [voxtralTranscriptHtml]="voxtralTranscriptHtml"
        [voxtralTranscriptSpeakers]="voxtralTranscriptSpeakers"
        [voxtralRecentCorrections]="voxtralRecentCorrections"
        [voxtralRecentRejections]="voxtralRecentRejections"
        [voxtralSessionApiBase]="voxtralSessionApiBase"
        [voxtralCorrectionApiSnapshot]="voxtralCorrectionApiSnapshot"
        [voxtralSegmentTimeline]="voxtralSegmentTimeline"
        [voxtralFilteredSegments]="voxtralFilteredSegments"
        [voxtralSegmentScopeFilter]="voxtralSegmentScopeFilter"
        (voxtralSegmentScopeFilterChange)="voxtralSegmentScopeFilter = $event"
        (blocklistAdd)="addToBlocklist($event)">
      </app-voxtral-live-data>
    </clr-accordion-content>
  </clr-accordion-panel>

  <!-- ================ Korrektur-Export Review ================ -->
  <clr-accordion-panel *ngIf="broadcast?.key" [(clrAccordionPanelOpen)]="open.export">
    <clr-accordion-title>
      Korrektur-Export Review
      <span class="count-badge" *ngIf="broadcast?.voxtralMini4bRealtimeSegmentsCount">
        {{ broadcast.voxtralMini4bRealtimeSegmentsCount }} Segmente in S3
      </span>
    </clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>
      <app-voxtral-export-review [broadcastKey]="broadcast.key"></app-voxtral-export-review>
    </clr-accordion-content>
  </clr-accordion-panel>

  <!-- ========================= PCMS ========================== -->
  <clr-accordion-panel [(clrAccordionPanelOpen)]="open.pcms">
    <clr-accordion-title>PCMS</clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>

      <div class="info-row">
        <span class="info-label">PCMS geladen:</span>
        <clr-checkbox-container class="info-value">
          <label>
            <input
              clrCheckbox
              type="checkbox"
              [checked]="broadcast?.isPcmsDownloaded"
              disabled
            />
          </label>
        </clr-checkbox-container>
      </div>

      <div class="info-row">
        <span class="info-label">Vortranskribiert:</span>
        <clr-checkbox-container class="info-value">
          <label>
            <input
              clrCheckbox
              type="checkbox"
              [checked]="broadcast?.isPretranscribed"
              disabled
            />
          </label>
        </clr-checkbox-container>
      </div>

      <div *ngIf="broadcast?.isPcmsDownloaded && broadcast?.pcmsUrl" class="info-row">
        <span class="info-label">PCMS URL:</span>
        <span class="info-value pcms-url" [title]="broadcast.pcmsUrl">{{ broadcast.pcmsUrl }}</span>
      </div>

      <div *ngIf="broadcast?.isPcmsDownloaded && broadcast?.pcmsImportDate" class="info-row">
        <span class="info-label">Import Datum:</span>
        <span class="info-value">{{ broadcast.pcmsImportDate | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
      </div>

      <div *ngIf="broadcast?.isPretranscribed && broadcast?.pcmsFabStlUploadDate" class="info-row">
        <span class="info-label">FAB Upload:</span>
        <span class="info-value">{{ broadcast.pcmsFabStlUploadDate | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
      </div>

      <!-- 2026-08-04 — operator recovery. While "Vortranskribiert" is set, the
           broadcast is invisible to every live KIUT pipeline. If the UT file in
           der UTDB turns out to be wrong, the operator deletes it there and
           clears the flag here; without this the reset waits for the next
           PcmsDownloadJob tick (up to 30 min), which is useless mid-broadcast. -->
      <div *ngIf="broadcast?.isPretranscribed" class="info-row">
        <span class="info-label">Live-KIUT:</span>
        <span class="info-value">
          <button
            class="btn btn-sm btn-warning-outline"
            [disabled]="resetPretranscribedSaving"
            (click)="onResetPretranscribed()"
          >
            {{ resetPretranscribedSaving ? 'Wird freigegeben…' : 'Live-KIUT wieder freigeben' }}
          </button>
          <span class="reset-pretranscribed-hint">
            Setzt „Vortranskribiert“ zurück. Vorher das UT-File in der UTDB löschen.
          </span>
        </span>
      </div>
      <div *ngIf="resetPretranscribedError" class="info-row">
        <span class="info-label"></span>
        <span class="info-value error-text">{{ resetPretranscribedError }}</span>
      </div>

      <div *ngIf="broadcast?.pcmsSizeInMb" class="info-row">
        <span class="info-label">Dateigröße:</span>
        <span class="info-value">{{ broadcast.pcmsSizeInMb }} MB</span>
      </div>

      <div *ngIf="broadcast?.audioDuration" class="info-row">
        <span class="info-label">Audio Dauer:</span>
        <span class="info-value">{{ formatAudioDuration(broadcast.audioDuration) }}</span>
      </div>

      <div *ngIf="broadcast?.pcmsStatus" class="info-row">
        <span class="info-label">PCMS Status:</span>
        <span class="info-value">{{ formatPcmsStatus(broadcast.pcmsStatus) }}</span>
      </div>
    </clr-accordion-content>
  </clr-accordion-panel>

  <!-- ===================== Transkription ===================== -->
  <clr-accordion-panel [(clrAccordionPanelOpen)]="open.transkription">
    <clr-accordion-title>
      Whisper-Transkription
      <span class="voxtral-status voxtral-running accordion-title-chip" *ngIf="broadcast && recordingStarted(broadcast)">Live</span>
    </clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>

      <!-- CloudWatch logs of the Whisper transcribe-live instance. -->
      <div class="info-row">
        <span class="info-label">Logs:</span>
        <span class="info-value">
          <button type="button" class="btn btn-sm btn-outline" (click)="openLogs()">Logs anzeigen</button>
        </span>
      </div>

      <div *ngIf="broadcast?.editorialNoteKey" class="info-row">
        <span class="info-label">Kontext:</span>
        <span class="info-value">
          vorhanden
          <span *ngIf="broadcast?.editorialNoteEditors"> (editiert von: {{ broadcast.editorialNoteEditors.join(', ') }})</span>
        </span>
      </div>

      <div *ngIf="broadcast?.instanceInitializing" class="info-row">
        <span class="info-label">Status:</span>
        <span class="info-value status-initializing">Wird initialisiert</span>
      </div>
      <div *ngIf="broadcast && recordingStarted(broadcast)" class="info-row">
        <span class="info-label">Status:</span>
        <span class="info-value status-recording">Live-Transkription</span>
      </div>

      <div *ngIf="broadcast?.recordingStartedAt" class="info-row">
        <span class="info-label">Start:</span>
        <span class="info-value">{{ broadcast.recordingStartedAt | date: 'HH:mm:ss' }}</span>
      </div>
      <div *ngIf="broadcast?.recordingStoppedAt" class="info-row">
        <span class="info-label">Ende:</span>
        <span class="info-value">{{ broadcast.recordingStoppedAt | date: 'HH:mm:ss' }}</span>
      </div>

      <div *ngIf="broadcast?.transcriptWordsCount" class="info-row">
        <span class="info-label">Wörter:</span>
        <span class="info-value">{{ broadcast.transcriptWordsCount | number }}</span>
      </div>

      <div *ngIf="broadcast?.transcriptSegmentsCount" class="info-row">
        <span class="info-label">Segmente:</span>
        <span class="info-value">{{ broadcast.transcriptSegmentsCount | number }}</span>
      </div>

      <div *ngIf="broadcast?.transcriptDuration" class="info-row">
        <span class="info-label">Dauer:</span>
        <span class="info-value">{{ formatTranscriptDuration(broadcast.transcriptDuration) }}</span>
      </div>

      <div *ngIf="broadcast?.transcriptModifiedDate" class="info-row">
        <span class="info-label">Bearbeitet am:</span>
        <span class="info-value">{{ broadcast.transcriptModifiedDate | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
      </div>

      <!-- Live Whisper lines (was an unstyled overflowing <pre> at the panel
           bottom) — wrapped, capped, only when non-empty. -->
      <pre class="live-lines" *ngIf="transcriptionLines.length">{{ transcriptionLines.join('\n') }}</pre>
    </clr-accordion-content>
  </clr-accordion-panel>

  <!-- ================ Editor (Video & Segmente) ============== -->
  <clr-accordion-panel [(clrAccordionPanelOpen)]="open.editor">
    <clr-accordion-title>Editor (Video &amp; Segmente)</clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>
      <!-- Lazy: presigned audio/video URL fetches now fire on first expand
           instead of on every panel open (matches the archive/statistics
           hosts, which also mount on demand). -->
      <app-transcription-editor [broadcast]="broadcast"></app-transcription-editor>
    </clr-accordion-content>
  </clr-accordion-panel>

  <!-- =================== Änderungsprotokoll ================== -->
  <clr-accordion-panel *ngIf="broadcast?.key" [(clrAccordionPanelOpen)]="open.audit">
    <clr-accordion-title>Änderungsprotokoll</clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>
      <app-broadcast-audit-log [broadcastKey]="broadcast.key"></app-broadcast-audit-log>
    </clr-accordion-content>
  </clr-accordion-panel>

</clr-accordion>

<!-- Sticky footer — only during a live Whisper KIUT session. -->
<div class="details-footer" *ngIf="broadcast?.transcribeLiveServiceIP">
  <app-emergency-stop-button
    [size]="stopButtonSize"
    [holdDurationMs]="1200"
    [label]="'NOT-AUS'"
    [activatedLabel]="'BEENDET'"
    [disabled]="!canManageBroadcasts"
    (stop)="stopRecording()">
  </app-emergency-stop-button>

  <button clrButton size="sm" [disabled]="!canManageBroadcasts" (click)="reinit()">Neustart</button>
</div>

<clr-modal [(clrModalOpen)]="showLogsModal" [clrModalSize]="'lg'" class="log-modal">
    <h3 class="modal-title">Logs für "{{ broadcast?.key }}"</h3>
    <div class="modal-body log-modal-body">
        <div *ngIf="isLoadingLogs">
            <clr-spinner clrMedium clrInline>Logs werden geladen…</clr-spinner>
        </div>
        <div *ngIf="!isLoadingLogs">
            <pre>{{ logs.join('\n\n') }}</pre>
        </div>
    </div>
    <div class="modal-footer">
        <button clrButton (click)="showLogsModal = false">Schließen</button>
    </div>
</clr-modal>
